const TABBABLE_SELECTOR = [
  "a[href]",
  "button",
  "input:not([type='hidden'])",
  "select",
  "textarea",
  "[tabindex]:not([tabindex='-1'])",
].join(",");

const isTabbable = (element: HTMLElement) => {
  const isDisabled =
    element.hasAttribute("disabled") ||
    element.getAttribute("aria-disabled") === "true";
  const isCommandOption = Boolean(
    element.closest("[cmdk-item], [cmdk-list], [cmdk-group]"),
  );
  const isVisible =
    element.getClientRects().length > 0 &&
    getComputedStyle(element).visibility !== "hidden";

  return !isDisabled && !isCommandOption && element.tabIndex >= 0 && isVisible;
};

export const focusNextTabbable = (
  currentElement: HTMLElement,
  isMovingBackward: boolean,
) => {
  const container = currentElement.closest('[role="dialog"]') ?? document.body;
  const tabbableElements = Array.from(
    container.querySelectorAll<HTMLElement>(TABBABLE_SELECTOR),
  ).filter(isTabbable);

  const currentIndex = tabbableElements.indexOf(currentElement);
  if (currentIndex === -1 || tabbableElements.length === 0) return;

  const nextIndex = isMovingBackward
    ? (currentIndex - 1 + tabbableElements.length) % tabbableElements.length
    : (currentIndex + 1) % tabbableElements.length;

  tabbableElements[nextIndex]?.focus();
};
